// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2BbXc","title":"Images45_title__1ZQZQ","images":"Images45_images__qvh7C"};